<div class="dealer-header head-bg" [ngClass]="{ 'callback-enabled': callback_enabled }" #header>
	<div class="container">
		<div *ngIf="website_url === null" class="dealer-name">
			<img
				src="//:0"
				*ngIf="dealer.branding.logo_on_header"
				class="dealer-logo"
				[attr.src]="dealer.branding.logo_on_header"
				[attr.alt]="dealer.name"
				[attr.data-element-view]="
					'dealer_logo_no_link__' + location + '_dealer_header__[' + dealer.branding.logo_on_header + ']'
				"
				[attr.data-element-click]="
					'dealer_logo_no_link__' + location + '_dealer_header__[' + dealer.branding.logo_on_header + ']'
				"
				(error)="handleDealerLogoError()"
				#dealerLogo
			/>
			<span
				class="dealer-name-text head-fg"
				[class.force-show]="!dealer.branding.logo_on_header"
				[attr.data-element-click]="
					'dealer_name_no_link__' + location + '_dealer_header__[' + dealer.friendly_name + ']'
				"
				#dealerName
			>
				{{ dealer.friendly_name }}
			</span>
		</div>
		<div *ngIf="website_url !== null" class="dealer-name">
			<a [href]="website_url">
				<img
					src="//:0"
					*ngIf="dealer.branding.logo_on_header"
					class="dealer-logo"
					[tooltip]="'Visit Dealer Showroom'"
					[placement]="'right'"
					[attr.src]="dealer.branding.logo_on_header"
					[attr.alt]="dealer.name"
					[attr.data-element-view]="
						'dealer_logo__' + location + '_dealer_header__[' + dealer.branding.logo_on_header + ']'
					"
					[attr.data-element-click]="
						'dealer_logo__' + location + '_dealer_header__[' + dealer.branding.logo_on_header + ']'
					"
					(error)="handleDealerLogoError()"
					#dealerLogo
				/>
				<span
					class="dealer-name-text head-fg"
					[class.force-show]="!dealer.branding.logo_on_header"
					[tooltip]="'Visit Dealer Showroom'"
					[placement]="'right'"
					[attr.data-element-click]="
						'dealer_name__' + location + '_dealer_header__[' + dealer.friendly_name + ']'
					"
					#dealerName
				>
					{{ dealer.friendly_name }}
				</span>
			</a>
		</div>
		<div *ngIf="configure_data?.meta?.enquiry_hash && !configure_data?.steps?.payment?.data?.full_payment?.full_payment_made"
		class="visible-md visible-lg visible-xl">
			<ui-popover-with-menu [location]="location + '_dealer_header'"></ui-popover-with-menu>
		</div>
		<div class="help-button-container">
			<a
				class="button small-button secondary-button button-with-icon-left"
				[attr.data-element-click]="'button__' + location + '_dealer_header__secondary-button[Help]'"
				(click)="onShowContact()"
			>
				<i class="icon-question-circle"></i>
				<span class="text">Help</span>
			</a>
		</div>
	</div>
</div>
